/**
 * @file: useVehiclePendingIssues.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useServiceSubjectsHost } from '@euler/app/flows/order/pages/ServiceSubjectsScreen/host';
import { ResourceAccessScope } from '@euler/model/enum';
import { PendingIssueWithDetails } from '@euler/model/PendingIssueWithDetails';
import { useServiceFactory } from '@euler/services/factory';
import { useAutoClearAsyncResource } from '@euler/utils/hooks';
import { useCallback } from 'react';

export function useVehiclePendingIssues() {
  const { vehicle } = useServiceSubjectsHost();
  const { vehicleInfoService } = useServiceFactory();
  const licensePlateNo = vehicle.licensePlateNo;
  const vin = vehicle.vin;

  const fetch = useCallback(async (): Promise<PendingIssueWithDetails[]> => {
    if (!vin || !licensePlateNo) {
      return [];
    }
    try {
      const res = await vehicleInfoService.getPendingIssues({
        vin,
        licensePlateNo,
        scope: ResourceAccessScope.Org,
      });
      return res;
    } catch (e) {
      console.error('fetch vehicle pending issue list failed: ', e);
      return [];
    }
  }, [licensePlateNo, vehicleInfoService, vin]);

  const key = ['vehicle-issues', licensePlateNo ?? '', vin ?? ''].join(':');

  return useAutoClearAsyncResource(fetch, key);
}
